import { render, staticRenderFns } from "./DeductionAmount.vue?vue&type=template&id=def3af20"
import script from "./DeductionAmount.vue?vue&type=script&lang=js"
export * from "./DeductionAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports